<template>
    <!-- 筛选 -->
    <ul class="nav vip-nav clearfix">
        <li><router-link class="curr" :to="{path:''+$parent.$parent.baseUrl+'/vipRight'}"><i class="icons nav-icon6 fl"></i>会员权益</router-link></li>
        <li v-if="$parent.$parent.isMajorAccount === 2"><router-link :to="{path:''+$parent.$parent.baseUrl+'/rechargeRecord'}"><i class="icons nav-icon6 fl"></i>充值记录</router-link></li>
        <li v-if="$parent.$parent.isMajorAccount === 2"><router-link :to="{path:''+$parent.$parent.baseUrl+'/vipBuy'}"><i class="icons nav-icon6 fl"></i>会员购买</router-link></li>
        <li v-if="$parent.$parent.isMajorAccount === 2"><router-link :to="{path:''+$parent.$parent.baseUrl+'/vipExchange'}"><i class="icons nav-icon6 fl"></i>会员兑换</router-link></li>
    </ul>
</template>
<script>
export default {
    data() {
        return {
           
        }
    },
    mounted() {
		
    },
    created() {
		
    },
    methods: {
        
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/vipMenu.vue